module.exports = "<div class=\"row padding-top20\">\n  <div class=\"padding-top20 padding-bottom20 color-gray text-center\">\n    <!-- Still have questions? <a class=\"cursor-pointer\">Click here</a> to chat with your dedicated ticket rep. -->\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/reusable/chat/chat.component.html
// module id = ./src/app/shared/reusable/chat/chat.component.html
// module chunks = main